"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadStreamTokenizer = void 0;

var AbstractTokenizer_1 = require("./AbstractTokenizer");

var peek_readable_1 = require("peek-readable");

var _debug = require("debug");

var debug = _debug('strtok3:ReadStreamTokenizer');

var maxBufferSize = 1 * 1000 * 1000;

var ReadStreamTokenizer = /*#__PURE__*/function (_AbstractTokenizer_1$) {
  _inherits(ReadStreamTokenizer, _AbstractTokenizer_1$);

  var _super = _createSuper(ReadStreamTokenizer);

  function ReadStreamTokenizer(stream, fileInfo) {
    var _this;

    _classCallCheck(this, ReadStreamTokenizer);

    _this = _super.call(this, fileInfo);
    _this.streamReader = new peek_readable_1.StreamReader(stream);
    return _this;
  }
  /**
   * Get file information, an HTTP-client may implement this doing a HEAD request
   * @return Promise with file information
   */


  _createClass(ReadStreamTokenizer, [{
    key: "getFileInfo",
    value: function () {
      var _getFileInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.fileInfo);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getFileInfo() {
        return _getFileInfo.apply(this, arguments);
      }

      return getFileInfo;
    }()
    /**
     * Read buffer from tokenizer
     * @param buffer - Target buffer to fill with data read from the tokenizer-stream
     * @param options - Read behaviour options
     * @returns Promise with number of bytes read
     */

  }, {
    key: "readBuffer",
    value: function () {
      var _readBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(buffer, options) {
        var offset, length, skipBytes, bytesRead;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // const _offset = position ? position : this.position;
                // debug(`readBuffer ${_offset}...${_offset + length - 1}`);
                offset = 0;
                length = buffer.length;

                if (!options) {
                  _context2.next = 15;
                  break;
                }

                if (Number.isInteger(options.length)) {
                  length = options.length;
                } else {
                  length -= options.offset || 0;
                }

                if (!options.position) {
                  _context2.next = 14;
                  break;
                }

                skipBytes = options.position - this.position;

                if (!(skipBytes > 0)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 9;
                return this.ignore(skipBytes);

              case 9:
                return _context2.abrupt("return", this.readBuffer(buffer, options));

              case 12:
                if (!(skipBytes < 0)) {
                  _context2.next = 14;
                  break;
                }

                throw new Error('`options.position` must be equal or greater than `tokenizer.position`');

              case 14:
                if (options.offset) {
                  offset = options.offset;
                }

              case 15:
                if (!(length === 0)) {
                  _context2.next = 17;
                  break;
                }

                return _context2.abrupt("return", 0);

              case 17:
                _context2.next = 19;
                return this.streamReader.read(buffer, offset, length);

              case 19:
                bytesRead = _context2.sent;
                this.position += bytesRead;

                if (!((!options || !options.mayBeLess) && bytesRead < length)) {
                  _context2.next = 23;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 23:
                return _context2.abrupt("return", bytesRead);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function readBuffer(_x, _x2) {
        return _readBuffer.apply(this, arguments);
      }

      return readBuffer;
    }()
    /**
     * Peek (read ahead) buffer from tokenizer
     * @param buffer - Target buffer to write the data read to
     * @param options - Read behaviour options
     * @returns Promise with number of bytes peeked
     */

  }, {
    key: "peekBuffer",
    value: function () {
      var _peekBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(buffer, options) {
        var offset, bytesRead, length, skipBytes, skipBuffer;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // const _offset = position ? position : this.position;
                // debug(`peek ${_offset}...${_offset + length - 1}`);
                offset = 0;
                length = buffer.length;

                if (!options) {
                  _context3.next = 18;
                  break;
                }

                if (options.offset) {
                  offset = options.offset;
                }

                if (Number.isInteger(options.length)) {
                  length = options.length;
                } else {
                  length -= options.offset || 0;
                }

                if (!options.position) {
                  _context3.next = 18;
                  break;
                }

                skipBytes = options.position - this.position;

                if (!(skipBytes > 0)) {
                  _context3.next = 16;
                  break;
                }

                skipBuffer = Buffer.alloc(length + skipBytes);
                _context3.next = 11;
                return this.peekBuffer(skipBuffer, {
                  mayBeLess: options.mayBeLess
                });

              case 11:
                bytesRead = _context3.sent;
                skipBuffer.copy(buffer, offset, skipBytes);
                return _context3.abrupt("return", bytesRead - skipBytes);

              case 16:
                if (!(skipBytes < 0)) {
                  _context3.next = 18;
                  break;
                }

                throw new Error('Cannot peek from a negative offset in a stream');

              case 18:
                _context3.prev = 18;
                _context3.next = 21;
                return this.streamReader.peek(buffer, offset, length);

              case 21:
                bytesRead = _context3.sent;
                _context3.next = 29;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](18);

                if (!(options && options.mayBeLess && _context3.t0 instanceof peek_readable_1.EndOfStreamError)) {
                  _context3.next = 28;
                  break;
                }

                return _context3.abrupt("return", bytesRead);

              case 28:
                throw _context3.t0;

              case 29:
                if (!((!options || !options.mayBeLess) && bytesRead < length)) {
                  _context3.next = 31;
                  break;
                }

                throw new peek_readable_1.EndOfStreamError();

              case 31:
                return _context3.abrupt("return", bytesRead);

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[18, 24]]);
      }));

      function peekBuffer(_x3, _x4) {
        return _peekBuffer.apply(this, arguments);
      }

      return peekBuffer;
    }()
  }, {
    key: "ignore",
    value: function () {
      var _ignore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(length) {
        var bufSize, buf, totBytesRead, remaining, bytesRead;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                debug("ignore ".concat(this.position, "...").concat(this.position + length - 1));
                bufSize = Math.min(maxBufferSize, length);
                buf = Buffer.alloc(bufSize);
                totBytesRead = 0;

              case 4:
                if (!(totBytesRead < length)) {
                  _context4.next = 14;
                  break;
                }

                remaining = length - totBytesRead;
                _context4.next = 8;
                return this.readBuffer(buf, {
                  length: Math.min(bufSize, remaining)
                });

              case 8:
                bytesRead = _context4.sent;

                if (!(bytesRead < 0)) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", bytesRead);

              case 11:
                totBytesRead += bytesRead;
                _context4.next = 4;
                break;

              case 14:
                return _context4.abrupt("return", totBytesRead);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function ignore(_x5) {
        return _ignore.apply(this, arguments);
      }

      return ignore;
    }()
  }]);

  return ReadStreamTokenizer;
}(AbstractTokenizer_1.AbstractTokenizer);

exports.ReadStreamTokenizer = ReadStreamTokenizer;